import { EventEmitter, NgZone, SimpleChanges } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CHART_METRIC_MENU_TYPE, CORRELATION_FIRST_SECURITY, CORRELATION_LIST_SECURITY, CORRELATION_SECURITY_OPTIONS, } from 'ChartApp/ts/features/fund-chart-page-shared/components/chart-correlation-selector-modal/constants';
import { CorrelationSecurityType, } from 'ChartApp/ts/interfaces/fund-chart.interface';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { getSecurityTypeFromId } from 'Angular/utils/security-utils';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "Angular/services/core/ajax.service";
import * as i3 from "Angular/services/core/urls.service";
import * as i4 from "../../../../../../../../../search/static/search/ts/features/autocomplete-in-place/metric-autocomplete-in-place/metric-autocomplete-in-place.component";
import * as i5 from "@angular/common";
import * as i6 from "@angular/forms";
import * as i7 from "../../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i8 from "../../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i9 from "../../../../../../../../../../ycharts/static/ts/features/components/inputs/simple-input/simple-input.component";
function CorrelationSecuritySelectorComponent_div_4_ycn_icon_search_autocomplete_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-icon-search-autocomplete", 14);
    i0.ɵɵlistener("submitHandler", function CorrelationSecuritySelectorComponent_div_4_ycn_icon_search_autocomplete_1_Template_ycn_icon_search_autocomplete_submitHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectSecurity($event)); });
    i0.ɵɵtext(1, "> ");
    i0.ɵɵelementEnd();
} }
function CorrelationSecuritySelectorComponent_div_4_ycn_simple_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-simple-input", 15);
    i0.ɵɵlistener("handler", function CorrelationSecuritySelectorComponent_div_4_ycn_simple_input_2_Template_ycn_simple_input_handler_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeSecurity()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("inputDisabled", true)("isClearable", true)("value", (ctx_r1._securityObj.security == null ? null : ctx_r1._securityObj.security.name) || "");
} }
function CorrelationSecuritySelectorComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r1._securityObj.metric == null ? null : ctx_r1._securityObj.metric.name, " is not available for ", ctx_r1._securityErrors.securityName, ". Select another metric. ");
} }
function CorrelationSecuritySelectorComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, CorrelationSecuritySelectorComponent_div_4_ycn_icon_search_autocomplete_1_Template, 2, 0, "ycn-icon-search-autocomplete", 11)(2, CorrelationSecuritySelectorComponent_div_4_ycn_simple_input_2_Template, 1, 3, "ycn-simple-input", 12)(3, CorrelationSecuritySelectorComponent_div_4_div_3_Template, 2, 2, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r1._securityObj.security == null ? null : ctx_r1._securityObj.security.name));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._securityObj.security == null ? null : ctx_r1._securityObj.security.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._securityErrors.security);
} }
function CorrelationSecuritySelectorComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "ycn-simple-input", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("inputDisabled", true)("isClearable", true)("value", ctx_r1.securityMessage);
} }
function CorrelationSecuritySelectorComponent_ycn_metric_autocomplete_in_place_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-metric-autocomplete-in-place", 18);
    i0.ɵɵlistener("submitHandler", function CorrelationSecuritySelectorComponent_ycn_metric_autocomplete_in_place_10_Template_ycn_metric_autocomplete_in_place_submitHandler_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectAutocompleteMetric($event)); })("submitModalHandler", function CorrelationSecuritySelectorComponent_ycn_metric_autocomplete_in_place_10_Template_ycn_metric_autocomplete_in_place_submitModalHandler_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectMetric($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("defaultOnly", ctx_r1.defaultOnly)("appendToBody", false)("displayIdentifier", null)("hideCancelButton", true)("searchType", ctx_r1.metricMenuType + "_calc")("tooltipText", "Edit Metric");
} }
function CorrelationSecuritySelectorComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r1._securityErrors.metricName, " is not available for ", ctx_r1._securityObj.security.name, ". Select another security. ");
} }
function CorrelationSecuritySelectorComponent_ycn_simple_input_12_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-simple-input", 20);
    i0.ɵɵlistener("handler", function CorrelationSecuritySelectorComponent_ycn_simple_input_12_Template_ycn_simple_input_handler_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeMetric()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDisabled", true)("isClearable", !!ctx_r1._securityObj.metric.id)("value", ctx_r1._securityObj.metric.name);
} }
function CorrelationSecuritySelectorComponent_div_13_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1, " Invalid weight. ");
    i0.ɵɵelementEnd();
} }
function CorrelationSecuritySelectorComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 5);
    i0.ɵɵtext(2, "Weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21)(4, "input", 22);
    i0.ɵɵtwoWayListener("ngModelChange", function CorrelationSecuritySelectorComponent_div_13_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1._securityObj.weight, $event) || (ctx_r1._securityObj.weight = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function CorrelationSecuritySelectorComponent_div_13_Template_input_ngModelChange_4_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateSecurityObj()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CorrelationSecuritySelectorComponent_div_13_div_5_Template, 2, 0, "div", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1._securityObj.weight);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._securityErrors.weight);
} }
function CorrelationSecuritySelectorComponent_div_14_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1, " Invalid lag. ");
    i0.ɵɵelementEnd();
} }
function CorrelationSecuritySelectorComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 5);
    i0.ɵɵtext(2, "Lag");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21)(4, "input", 22);
    i0.ɵɵtwoWayListener("ngModelChange", function CorrelationSecuritySelectorComponent_div_14_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1._securityObj.lag, $event) || (ctx_r1._securityObj.lag = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function CorrelationSecuritySelectorComponent_div_14_Template_input_ngModelChange_4_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateSecurityObj()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CorrelationSecuritySelectorComponent_div_14_div_5_Template, 2, 0, "div", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1._securityObj.lag);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._securityErrors.lag);
} }
/**
 * Correlation Security Selector Component
 *
 * Required Attributes
 *
 * & correlationDataChangeHandler: Handler function to pass new / updated correlation object to.
 * < correlationType: Type of the correlation ('ratio', 'spread', 'correlation')
 * @ label: Descriptive label for the correlation security object
 * < securityErrors: JS Object representing errors passed in from parent scope
 * & securityErrorsChangeHandler: JS Function to update error objects
 * & securityErrorsChangeHandler: JS Function to update error objects
 * < securityObj: JS Object representing security object
 * @ securityOption: String representing the object property of the security ('securityA' or 'securityB')
 *      passed in from parent scope.
 */
const firstListSecurityIdMap = {
    [CORRELATION_FIRST_SECURITY]: 'first',
    [CORRELATION_LIST_SECURITY]: 'list',
};
const noMetricObj = { name: 'N/A: Metrics are not available for economic data.', id: '' };
function isFirstOrListSecurity(securityId) {
    return CORRELATION_SECURITY_OPTIONS.indexOf(securityId) > -1;
}
export class CorrelationSecuritySelectorComponent {
    constructor(ngZone, securitiesService, ajaxService, urlsService) {
        this.ngZone = ngZone;
        this.securitiesService = securitiesService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.label = '';
        this.defaultOnly = false;
        this.securityErrorsHandler = new EventEmitter();
        this.correlationDataChangeHandler = new EventEmitter();
        this.securityTypeLabel = '';
        this.securityDropdownConfig = {};
        this.metricMenuType = CHART_METRIC_MENU_TYPE;
        this._securityObj = {};
        this._securityErrors = {};
        this.securityMessage = '';
    }
    ngOnInit() {
        this.securityTypeLabel = `${this.label} : FIXED`;
        this.securityDropdownConfig = {
            title: {
                label: this.securityTypeLabel,
            },
            list: [
                {
                    type: 'option',
                    label: `${this.label} : FIRST`,
                    value: CorrelationSecurityType.FIRST,
                },
                {
                    type: 'option',
                    label: `${this.label} : LIST`,
                    value: CorrelationSecurityType.LIST,
                },
                {
                    type: 'option',
                    label: `${this.label} : FIXED`,
                    value: CorrelationSecurityType.FIXED,
                },
            ],
        };
    }
    ngOnChanges(changeObj) {
        // On edit, the first change will have a populated securityObj
        if (changeObj.securityObj?.currentValue) {
            this._securityObj = { ...changeObj.securityObj.currentValue };
        }
        if (changeObj.securityObj?.currentValue?.security) {
            this.onSecurityIdSelect(this._securityObj.security.id);
        }
        if (changeObj.securityObj?.currentValue?.metric) {
            this.metricIdSelect(this._securityObj.metric);
        }
        if (changeObj.securityObj?.currentValue?.securityType) {
            this.changeSecurityType(this._securityObj.securityType);
        }
        if (changeObj.securityErrors?.currentValue) {
            this._securityErrors = { ...changeObj.securityErrors.currentValue };
        }
    }
    changeSecurityType(securityType) {
        this._securityObj.securityType = securityType;
        switch (securityType) {
            case CorrelationSecurityType.FIRST:
                this._securityObj.security = { id: '_firstSecurity_', name: 'First Security' };
                this.securityDropdownConfig.title = { label: `${this.label} : FIRST` };
                this.securityMessage = 'First Security - Locked';
                break;
            case CorrelationSecurityType.LIST:
                this._securityObj.security = { id: '_listSecurity_', name: 'List Security' };
                this.securityDropdownConfig.title = { label: `${this.label} : LIST` };
                this.securityMessage = 'List Security - Locked';
                break;
            case CorrelationSecurityType.FIXED:
                this._securityObj.security = '';
                this.securityDropdownConfig.title = { label: `${this.label} : FIXED` };
                this.securityMessage = '';
                break;
            default:
                break;
        }
        if (this._securityObj.security?.type === 'indicator') {
            this.removeMetric();
        }
        this.updateSecurityObj();
    }
    selectAutocompleteMetric(metric) {
        // We need to make sure this fires after the modal's digest cycle!!
        this.ngZone.run(() => {
            return this.metricIdSelect({
                id: metric.search_id,
                name: metric.name,
            });
        });
    }
    selectMetric(metric) {
        // We need to make sure this fires after the modal's digest cycle!!
        this.ngZone.run(() => {
            return this.metricIdSelect({
                id: metric.internal_name,
                name: metric.label,
            });
        });
    }
    removeMetric() {
        this._securityObj.metric = '';
        this.updateSecurityObj();
    }
    async metricIdSelect(metric) {
        if (!metric.id) {
            return false;
        }
        const isValid = await this.validateMetricAndSecurity(metric, this._securityObj.security);
        if (!isValid) {
            this._securityErrors.metric = true;
            this._securityErrors.metricName = metric.name;
            this.securityErrorsHandler.emit({
                securityErrors: this._securityErrors,
                securityOption: this.securityOption,
            });
            return false;
        }
        this._securityErrors.metric = false;
        this._securityErrors.metricName = null;
        this._securityObj.metric = metric;
        this.updateSecurityObj();
        return true;
    }
    selectSecurity(object) {
        this.onSecurityIdSelect(object.search_id);
    }
    removeSecurity() {
        if (this._securityObj.metric === noMetricObj) {
            this.removeMetric();
        }
        this._securityObj.security = '';
        this.updateSecurityObj();
    }
    onSecurityIdSelect(securityId) {
        if (securityId) {
            if (isFirstOrListSecurity(securityId)) {
                this._securityErrors.security = false;
                this.changeSecurityType(firstListSecurityIdMap[securityId]);
            }
            else {
                this.securitiesService.getSecuritiesInfo(securityId).subscribe(async (data) => {
                    if (data.length > 0) {
                        const securityFullName = `${data[0].security_name} (${data[0].display_security_id})`;
                        const security = { name: securityFullName, id: data[0].id };
                        // Since selection of an economic indicator will wipe out the existing metric selection, we will
                        // send an empty metric id for the metric-security validation if the security is an indicator
                        const securityType = getSecurityTypeFromId(securityId);
                        const metric = securityType === 'indicator' ? noMetricObj : this._securityObj.metric;
                        const isValid = await this.validateMetricAndSecurity(metric, security);
                        if (!isValid) {
                            this._securityErrors.security = true;
                            this._securityErrors.securityName = security.name;
                            this.securityErrorsHandler.emit({
                                securityErrors: this._securityErrors,
                                securityOption: this.securityOption,
                            });
                        }
                        else {
                            this._securityErrors.security = false;
                            this._securityErrors.securityName = null;
                            this._securityObj.security = security;
                            this.updateSecurityObj();
                            if (securityType === 'indicator') {
                                this._securityObj.metric = noMetricObj;
                                this.metricIdSelect(noMetricObj);
                            }
                        }
                    }
                });
            }
        }
    }
    updateSecurityObj() {
        this.ngZone.run(() => {
            this.correlationDataChangeHandler.emit({
                securityObj: this._securityObj,
                securityOption: this.securityOption,
            });
        });
    }
    async validateMetricAndSecurity(metric, security) {
        if (isFirstOrListSecurity(security?.id)) {
            return true;
        }
        if (metric && security) {
            return JSON.parse(await firstValueFrom(this.ajaxService.getDataObserveBody(this.urlsService.getUrl(this.urlsService.CHARTS.SECURITY_METRIC_CHARTABLE, {
                security_id: security.id,
                metric: metric.id,
            }))));
        }
        // return true if only one has been selected
        return true;
    }
}
CorrelationSecuritySelectorComponent.ɵfac = function CorrelationSecuritySelectorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CorrelationSecuritySelectorComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.AjaxService), i0.ɵɵdirectiveInject(i3.UrlsService)); };
CorrelationSecuritySelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CorrelationSecuritySelectorComponent, selectors: [["ycn-correlation-security-selector"]], inputs: { correlationType: "correlationType", label: "label", securityErrors: "securityErrors", securityObj: "securityObj", securityOption: "securityOption", defaultOnly: "defaultOnly" }, outputs: { securityErrorsHandler: "securityErrorsHandler", correlationDataChangeHandler: "correlationDataChangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 15, vars: 8, consts: [[1, "modal-section"], [1, "row", "form-row"], [1, "col", "modal-sidebar"], ["buttonClass", "btn btn-secondary btn-block style-underline", 1, "page-header-action", "dropdown", 3, "handler", "config"], ["class", "col", 4, "ngIf"], [1, "col", "modal-sidebar", "form-label", "col-form-label"], [1, "col"], ["class", "field-search-browse-wrap", 3, "defaultOnly", "appendToBody", "displayIdentifier", "hideCancelButton", "searchType", "tooltipText", "submitHandler", "submitModalHandler", 4, "ngIf"], ["data-test-id", "metric-error-message", "class", "feedback feedback-invalid", 4, "ngIf"], ["data-test-id", "disabled-metric-input", 3, "inputDisabled", "isClearable", "value", "handler", 4, "ngIf"], ["class", "row form-row", 4, "ngIf"], ["class", "input-group", "inputPlaceholder", "Search Securities", "resultType", "categories", "searchType", "main", "submitButtonType", "icon-search", 3, "submitHandler", 4, "ngIf"], [3, "inputDisabled", "isClearable", "value", "handler", 4, "ngIf"], ["data-test-id", "security-error-message", "class", "feedback feedback-invalid", 4, "ngIf"], ["inputPlaceholder", "Search Securities", "resultType", "categories", "searchType", "main", "submitButtonType", "icon-search", 1, "input-group", 3, "submitHandler"], [3, "handler", "inputDisabled", "isClearable", "value"], ["data-test-id", "security-error-message", 1, "feedback", "feedback-invalid"], [3, "inputDisabled", "isClearable", "value"], [1, "field-search-browse-wrap", 3, "submitHandler", "submitModalHandler", "defaultOnly", "appendToBody", "displayIdentifier", "hideCancelButton", "searchType", "tooltipText"], ["data-test-id", "metric-error-message", 1, "feedback", "feedback-invalid"], ["data-test-id", "disabled-metric-input", 3, "handler", "inputDisabled", "isClearable", "value"], [1, "col-3"], ["type", "number", 1, "form-control", "corlLag", 3, "ngModelChange", "ngModel"], ["class", "feedback feedback-invalid", 4, "ngIf"], [1, "feedback", "feedback-invalid"]], template: function CorrelationSecuritySelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "ycn-simple-dropdown", 3);
        i0.ɵɵlistener("handler", function CorrelationSecuritySelectorComponent_Template_ycn_simple_dropdown_handler_3_listener($event) { return ctx.changeSecurityType($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(4, CorrelationSecuritySelectorComponent_div_4_Template, 4, 3, "div", 4)(5, CorrelationSecuritySelectorComponent_div_5_Template, 2, 3, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 1)(7, "label", 5);
        i0.ɵɵtext(8, "Metric");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtemplate(10, CorrelationSecuritySelectorComponent_ycn_metric_autocomplete_in_place_10_Template, 1, 6, "ycn-metric-autocomplete-in-place", 7)(11, CorrelationSecuritySelectorComponent_div_11_Template, 2, 2, "div", 8)(12, CorrelationSecuritySelectorComponent_ycn_simple_input_12_Template, 1, 3, "ycn-simple-input", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(13, CorrelationSecuritySelectorComponent_div_13_Template, 6, 2, "div", 10)(14, CorrelationSecuritySelectorComponent_div_14_Template, 6, 2, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("config", ctx.securityDropdownConfig);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._securityObj.securityType === "fixed");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._securityObj.securityType !== "fixed");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !(ctx._securityObj.metric == null ? null : ctx._securityObj.metric.name));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._securityErrors.metric);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._securityObj.metric == null ? null : ctx._securityObj.metric.name);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.correlationType === "spread");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.correlationType === "correlation");
    } }, dependencies: [i4.MetricAutocompleteInPlaceComponent, i5.NgIf, i6.DefaultValueAccessor, i6.NumberValueAccessor, i6.NgControlStatus, i6.NgModel, i7.IconSearchAutocompleteComponent, i8.SimpleDropdownComponent, i9.SimpleInputComponent], encapsulation: 2 });
